<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md3>
          <v-card class="elevation-1">
            <v-toolbar color="white" class="elevation-0 login-toolbar">
              <v-toolbar-title>Forgot Password</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn flat small color="primary" class="text-transform-none font-weight-thin" to="/login">Login</v-btn>
            </v-toolbar>
            <v-form class="pa-3" v-model="valid">
              <v-card-text>
                <v-text-field v-model="email" :disabled="processing" :rules="emailRules" prepend-icon="mail_outline" name="email" label="Email" required autofocus></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block round :disabled="!valid || processing" :loading="processing" @click.native="resetRequest" color="primary" class="px-4">
                Submit
                <span slot="loader">Processing...</span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
          <powered-by />
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>    
</template>

<script>

  import PoweredBy from '../components/PoweredBy'

  export default {
    data: () => ({
      valid: false,
      processing: false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
      ]
    }),
    methods: {
      resetRequest: function(){
        this.processing = true
        this.axios.put(this.config.apis.forgotPassword, {
            email: this.email
          })
          .then((response) => {

            this.notify('forgotPasswordSuccess', 'success')
            
          })
          .catch((error) => {
            this.processing = false
          });
      }
    },
    components: {
      'powered-by': PoweredBy
    }
  }
</script>